<template>
<v-card flat class="transparent">

  <v-card flat id="postwrapper" class="transparent">
      <v-layout row class="justify-center my-1">
          <v-btn-toggle dark id="PostInsertButtons" style="display:none">
                <input class="tool-items fa fa-file-image-o" type="file" accept="image/*" id="file" @change="getImage()" hidden ref="postimage">           
              <v-btn icon small @click="$refs.postimage.click()">
                <v-icon small>mdi-file-image</v-icon>
              </v-btn>
              <v-btn icon small>
                <v-icon small @click="link()">mdi-link</v-icon>
              </v-btn>
              <v-btn icon small>
                <v-icon small @click="addphone()">mdi-phone</v-icon>
              </v-btn>
              <v-btn icon small>
                <v-icon small @click="addemail()">mdi-email</v-icon>
              </v-btn>
              <v-btn icon small onclick="document.execCommand('insertUnorderedList',false,'')">
                <v-icon small>mdi-format-list-bulleted</v-icon>
              </v-btn>
        </v-btn-toggle>
    </v-layout>                        
      <v-layout row class="justify-center my-1">  
        <v-card flat :width="inputwidth"  class="transparent">                      
          <div flat contenteditable="true" class="postinputbox"  id="postinput">
          </div> 
          <v-card-actions class="my-1">
            <v-spacer></v-spacer>
            <v-btn @click="CreatePost()" style="display:none" id="CreatePostButton" text>Post</v-btn><v-btn @click="CancelPost()"  style="display:none" id="CancelPostButton" icon ><v-icon color="red">mdi-cancel</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-card>
  <v-card flat class="transparent">
    <v-row  v-for="post in PostsTimeline" :key="post.itemObjkey"
      class="fill-height my-5"
      align="center"
      >
      <v-card shaped elevation="4" class="mx-1 my-2" width="100%">
        <v-card-title >
          <v-list class="transparent" width="100%">
          <v-list-item>
          <v-list-item-avatar>
              <img v-if="post.creatorimg"
                :src="post.creatorimg"
                :alt="post.creatorname"
            >
            <img v-if="!post.creatorimg"
                src='@/assets/blank-profile-picture-973460_640.png'
                :alt="post.creatorname"
            >
            
          </v-list-item-avatar>
            <v-list-item-content style="font-size:10px">
              <b><a :href="'/User/'+post.Creatorid">{{post.creatorname}}</a></b>
            </v-list-item-content>
            <v-list-item-content style="font-size:10px" v-if="post.createdon">
              <span v-if="typeof post.createdon.toDate !== 'undefined'">{{post.createdon}}</span>
              <span v-else>{{post.createdon}}</span>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
          <v-list-item-content v-html="post.post" style="font-size:14px">
              
            </v-list-item-content>
            </v-list-item>
      </v-list> 
        </v-card-title>
        <!-- <v-layout row wrap class="justify-center mx-3">
          
        </v-layout> -->
              <v-divider></v-divider>
              
              <v-card-actions>
                <v-layout row wrap class="justify-space-between mx-3">
         

    <v-btn icon small>
      <v-badge dark overlap>
        <v-icon small color="blue" @click="LikePost(post)">mdi-thumb-up-outline</v-icon>
        <span slot="badge"> {{post.Likes.length}} </span>
      </v-badge>
      
    </v-btn>

    <v-btn icon>
      <v-icon color="orange">mdi-tag-outline</v-icon>
    </v-btn>

    <v-btn icon>
      <v-icon color="pop">mdi-share-circle</v-icon>
    </v-btn>
                </v-layout>
              </v-card-actions>
              <v-divider></v-divider>
              
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header :id="post.id+'commentpanel'">
                    <v-layout row wrap class="justify-center mx-3">
                        <v-btn icon small>
                            <v-icon small color="blue">mdi-thumb-up-outline</v-icon>
                                          
                        </v-btn>
                      <span> {{post.Likes.length}} Likes</span> 
                      
                        <v-btn icon small>
                            <v-icon small color="orange">mdi-comment-outline</v-icon>
                        </v-btn>
                      <span> {{post.Comments.length}} Comments</span> 
                      </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <v-list dense class="my-1" width="100%" v-for="comment in post.Comments" :key="comment.itemObjkey">
                      <!-- <v-list dense> -->
                      <v-list-item>
                      <v-list-item-avatar>
                          <img v-if="comment.creatorimg"
                            :src="comment.creatorimg"
                            :alt="comment.creatorname"
                        >
                        <img v-if="!comment.creatorimg"
                            src='@/assets/blank-profile-picture-973460_640.png'
                            :alt="comment.creatorname"
                        >
                        
                      </v-list-item-avatar>
                        <v-list-item-content>
                          <!-- <v-chip
                            large
                          > -->
                          <div class="commentblock">
                          <v-list class="transparent" dense width="90%">
                            <v-list-item style="font-size:10px">
                            <b><a :href="'/User/'+comment.Creatorid">{{comment.creatorname}}</a></b>
                            </v-list-item>
                            <v-list-item>
                            {{comment.content}}
                            </v-list-item>
                          </v-list>
                          </div>
                          <!-- </v-chip> -->
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-btn icon small>
                        <v-badge dark overlap>
                          <v-icon small color="blue" @click="LikeComment(comment)">mdi-thumb-up-outline</v-icon>
                          <span slot="badge"> {{comment.Likes.length}} </span>
                        </v-badge>
                        
                      </v-btn>
                      <v-btn icon small>
                        <v-badge dark overlap>
                          <v-icon small color="blue" @click="ReplyBoxActivate(comment.id+'replyboxbreak',comment.id+'replyinputchip')">mdi-reply</v-icon>
                          <span slot="badge"> {{comment.Replies.length}} </span>
                        </v-badge>
                        
                      </v-btn>
                      </v-list-item>
                      <v-list-item :id="comment.id+'replyboxbreak'"  style="display:none">
                      <!-- <v-list> -->
                        <!-- <v-list-item :id="i+'commentreply'" style="display:none"> -->
                          <v-avatar size="35" :id="comment.id+'replyinputavatar'">
                            <img :src="UserRecord.profilephoto"/>
                          </v-avatar><input @blur="ReplyBoxDeactivate(comment.id+'replyboxbreak',comment.id+'replyinputchip')" class="Chipinput mx-3" type="text" @keydown.enter="ReplytoComment(comment)" placeholder="Reply Here" :id="comment.id+'replyinputchip'">
                          
                        <!-- </v-list-item>
                      </v-list>                       -->
                      </v-list-item>
                       <!-- </v-list> 
                       <v-list dense> -->
                         <v-list-item  v-for="reply in comment.Replies" :key="reply.itemObjKey">
                            <v-list class="transparent" dense width="90%">
                                  <v-list-item>
                                    
                            <v-list-item-avatar>
                                <img v-if="reply.creatorimg"
                                  :src="reply.creatorimg"
                                  :alt="reply.creatorname"
                              >
                              <img v-if="!reply.creatorimg"
                                  src='@/assets/blank-profile-picture-973460_640.png'
                                  :alt="reply.creatorname"
                              >
                              
                            </v-list-item-avatar>
                              <v-list-item-content>
                                <!-- <v-chip
                                  large
                                > -->
                                <div class="commentblock">
                                <v-list class="transparent" dense width="90%">
                                  <v-list-item style="font-size:10px">
                                  <b><a :href="'/User/'+reply.Creatorid">{{reply.creatorname}}</a></b>
                                  </v-list-item>
                                  <v-list-item>
                                  {{reply.content}}
                                  </v-list-item>
                                </v-list>
                                </div>
                                <!-- </v-chip> -->
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-spacer></v-spacer>
                                <v-btn icon small>
                                <v-badge dark overlap>
                                  <v-icon small color="blue" @click="LikeReply(reply)">mdi-thumb-up-outline</v-icon>
                                  <span slot="badge"> {{reply.Likes.length}} </span>
                                </v-badge>
                                
                              </v-btn>
                              <v-btn icon small>
                                <v-badge dark overlap>
                                  <v-icon small color="blue" @click="ReplyBoxActivate(reply.id+'replyboxbreak',reply.id+'replytoreplyinputchip')">mdi-reply</v-icon>
                                  <span slot="badge"> {{reply.Replies.length}} </span>
                                </v-badge>
                                
                              </v-btn>
                              </v-list-item>
                              <!-- <v-list>
                                <v-list-item> -->
                                  <v-list-item :id="reply.id+'replyboxbreak'" style="display:none">
                                  <v-avatar size="35">
                                    <img :src="UserRecord.profilephoto"/>
                                  </v-avatar><input @blur="ReplyBoxDeactivate(reply.id+'replyboxbreak',reply.id+'replytoreplyinputchip')" class="Chipinput mx-3" type="text"  @keydown.enter="ReplytoReply(reply,comment)"  placeholder="Reply to reply" :id="reply.id+'replytoreplyinputchip'">
                                  
                               <!-- </v-list-item>
                              </v-list>                      -->
                              </v-list-item>
                                </v-list>
                            </v-list-item>
                      
                      
                  </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
             
           
                 
                     
                   
        
           
               <v-card-actions class="commentpost">
                
          <v-avatar size="50">
            <img :src="UserRecord.profilephoto"/>
          </v-avatar><input class="Chipinput mx-3" type="text" @keydown.enter="CommenttoPost(post)" placeholder="Insert Comment" id="commentinputchip"/>
                
              </v-card-actions>
              
            </v-card>  
            </v-row>
          </v-card>  

</v-card>
</template>

<script>

import firebase from 'firebase';
import db from '@/main'
import format from 'date-fns/format'
import axios from 'axios'

export default {
    props: ['UserRecord'],
    components: {
    
        },
    data() {
        return {
          NewCommentInput: '',
          NewReplyInput: '',
            Posts: [],
            SocialComments: [],
            SocialReplies: [],
            SocialLikes: [],
            WritingPost: false,
            inputwidth: '90%',
            postelmnt: '',
        }
        
    },

    created(){
      this.GetSitePosts()
      this.GetSocialComments()
      this.GetSocialLikes()
      this.GetSocialReplies()
        window.onload = setTimeout(() => {
          document.addEventListener("focusin", function(e) {
            var x = document.activeElement.id
          let stylebuttons = document.getElementById('PostInsertButtons')
          let createpostbtn = document.getElementById('CreatePostButton')
          let cancelpostbtn = document.getElementById('CancelPostButton')
          let postwrapper = document.getElementById('postwrapper')
          if(x === 'postinput'){
              stylebuttons.style.display = 'block'
              createpostbtn.style.display = 'block'
              cancelpostbtn.style.display = 'block'
              postwrapper.style.outlineStyle = 'solid'
              postwrapper.style.outlineColor = '#dee6ec'
              postwrapper.style.outlineWidth = "1px"
          }
          
        });
          
          this.postelmnt = document.getElementById("postinput")          
          document.getElementById("postinput").addEventListener("paste", function(e) {
          e.preventDefault();
          if (e.clipboardData && e.clipboardData.getData) {
            var text = e.clipboardData.getData("text/plain");
            document.execCommand("insertHTML", false, text);
          } else if (window.clipboardData && window.clipboardData.getData) {
            var text = window.clipboardData.getData("Text");
            insertTextAtCursor(text);
          }
        });
        
      }, 300);

    },

    watch: {
    // WritingPost (value) {
    //   if (value !== null && value !== undefined && value === true) {
    //     // this.inputwidth = '90%'
    //     // let postelmnt = document.getElementById('postinput')
    //     setTimeout(() => {
    //         this.postelmnt.focus()
    //       }, 100); 

    //   }
    //   else{
    //     // this.inputwidth = "100%"
    //   }
    // }
  },

    computed: {
      ComputedSocialReplies(){
        return this.SocialReplies.map(mainreply => {
          this.SocialReplies.map(reply => {
                    if(reply.relatedid === mainreply.id){
                      let replyonmainreplycheck = mainreply.Replies.find(obj => obj.id == reply.id)
                      if(!replyonmainreplycheck){
                        mainreply.Replies.push(reply)
                      }
                    }
                  })
          return mainreply
        }).map(mainreply => {
          this.SocialLikes.map(like => {
                    if(like.relatedid === mainreply.id){
                      let likeonmainreplycheck = mainreply.Likes.find(obj => obj.id == like.id)
                      if(!likeonmainreplycheck){
                        mainreply.Likes.push(like)
                      }
                    }
                  })
          return mainreply
        })
      },
      ComputedSocialComments(){
        return this.SocialComments.map(comment => {
          this.ComputedSocialReplies.map(reply => {
                    if(reply.relatedid === comment.id){
                      let replyoncommentcheck = comment.Replies.find(obj => obj.id == reply.id)
                      if(!replyoncommentcheck){
                        if(reply.Replies){
                          comment.Replies = comment.Replies.concat(reply.Replies)
                        }
                        comment.Replies.push(reply)
                      }
                    }
                  })
          return comment
        }).map(comment => {
          this.SocialLikes.map(like => {
                    if(like.relatedid === comment.id){
                      let likeoncommentcheck = comment.Likes.find(obj => obj.id == like.id)
                      if(!likeoncommentcheck){
                        comment.Likes.push(like)
                      }
                    }
                  })
          return comment
        })
      },
      PostsTimeline () {
        return this.Posts.map(post => {
          this.ComputedSocialComments.map(comment => {
            if(comment.relatedid === post.id){
              let oncheck = post.Comments.find(obj => obj.id == comment.id)
                if(!oncheck){
                  post.Comments.push(comment)
                }
              }   
          })
          return post
        }).map(post => {
          this.SocialLikes.map(like => {
            if(like.relatedid === post.id){
              let oncheck = post.Likes.find(obj => obj.id == like.id)
                if(!oncheck){
                  post.Likes.push(like)
                }
              }   
          })
          return post
        }).map(post => {
          this.ComputedSocialReplies.map(reply => {
            if(reply.relatedid === post.id){
              let oncheck = post.Likes.find(obj => obj.id == reply.id)
                if(!oncheck){
                  post.Likes.push(reply)
                }
              }   
          })
          return post
        }).map(post => {          
          if(typeof post.createdon.toDate !== 'undefined'){
            let dataobj = post.createdon.toDate()
            post.createdon = this.TimestampFormatterSTRING(dataobj)
          }
          return post
        }).slice().reverse()
      },

    },

    methods: {
      TimestampFormatterSTRING(d){
       
        var months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      
        var hr = d.getHours();
       
        var min = d.getMinutes();
        if (min < 10) {
            min = "0" + min;
        }
        if(hr < 10){
          hr = "0"+hr
        }
        
        var date = d.getDate();
        var month = months[d.getMonth()];
        var year = d.getFullYear();
        // 2020-03-15 09:00'
        let finaldate = format(d,'yyyy-MM-dd')+' '+hr+ ":" + min;
        console.log(finaldate)
        return finaldate
      },
      ReplyBoxDeactivate(replyboxbreak,input){
        let replyboxbreakelmnt = document.getElementById(replyboxbreak)
        let inputelmnt = document.getElementById(input)
        inputelmnt.value = ''
        replyboxbreakelmnt.style.display = 'none'
      },
      ReplyBoxActivate(replyboxbreak,input){
        let replyboxbreakelmnt = document.getElementById(replyboxbreak)
        let inputelmnt = document.getElementById(input)
        replyboxbreakelmnt.style.display = ''
        inputelmnt.focus()
      },
      GetSocialLikes(){
          db.collection('socialsitelikes').onSnapshot(res => {

            const changes = res.docChanges();
            changes.forEach(change => {
              if (change.type === 'added') {
                this.SocialLikes.push({
                  ...change.doc.data(),
                  id: change.doc.id
                })
              }
            })
          })
        },
        GetSocialReplies(){
          db.collection('socialsitereplies').onSnapshot(res => {

            const changes = res.docChanges();
            changes.forEach(change => {
              if (change.type === 'added') {
                this.SocialReplies.push({
                  ...change.doc.data(),
                  id: change.doc.id
                })
              }
            })
          })
        },
      GetSocialComments(){
          db.collection('socialsitecomments').onSnapshot(res => {

            const changes = res.docChanges();
            changes.forEach(change => {
              if (change.type === 'added') {
                this.SocialComments.push({
                  ...change.doc.data(),
                  id: change.doc.id
                })
              }
            })
          })
        },
        GetSitePosts(){
          db.collection('socialsiteposts').onSnapshot(res => {

            const changes = res.docChanges();
            changes.forEach(change => {
              if (change.type === 'added') {
                this.Posts.push({
                  ...change.doc.data(),
                  id: change.doc.id
                })
              }
            })
          })
        },
        CancelPostActive(){
          var x = document.activeElement.id      
          let postwrapper = document.getElementById('postwrapper')  
          let cancelpostbtn = document.getElementById('CancelPostButton')
          let createpostbtn = document.getElementById('CreatePostButton')
          let stylebuttons = document.getElementById('PostInsertButtons')     
              cancelpostbtn.style.display = 'none'
              createpostbtn.style.display = 'none'
              stylebuttons.style.display = 'none'
              postwrapper.style.outlineStyle = 'none'
              postwrapper.style.outlineColor = 'black'
              postwrapper.style.outlineWidth = "0px"
      },
      getImage() {
        var canvas=document.createElement("canvas"); 
        var ctx=canvas.getContext("2d");
        var cw=canvas.width;
        var ch=canvas.height;
        var maxW=400;
        var maxH=400;
      let elementid = 'postinput'
  
      var file = document.querySelector("input[type=file]").files[0];
      var fileSize = file.size;
      console.log(fileSize/1000000+'mb')
      var img = new Image;
        img.onload = function() {
          var iw=img.width;
          var ih=img.height;
          var scale=Math.min((maxW/iw),(maxH/ih));
          var iwScaled=iw*scale;
          var ihScaled=ih*scale;
          canvas.width=iwScaled;
          canvas.height=ihScaled;
          
          ctx.drawImage(img,0,0,iwScaled,ihScaled);
          
      let basetext = canvas.toDataURL("image/jpeg",0.6);
        console.log(basetext)
        let NEWeditorContent = document.getElementById(elementid)
        let newimg = document.createElement("img")
        newimg.src = basetext;
        newimg.width = 400
        newimg.style.marginLeft = "auto"
        newimg.style.marginRight = "auto"    
        newimg.style.display = 'block'
        document.execCommand('insertHTML', false, '<br>');
        NEWeditorContent.appendChild(newimg);
        document.execCommand('insertHTML', false, '<br>');
        }
        img.src = URL.createObjectURL(file);
      
    },

    ProcessImage(){
      var reader = new FileReader();

      let dataURI;

      reader.addEventListener(
        "load",
        function() {
          dataURI = reader.result;
          const img = document.createElement("img");          
          img.src = dataURI;
          img.width = 400
          img.style.marginLeft = "auto"
          img.style.marginRight = "auto"    
          img.style.display = 'block'    
          let NEWeditorContent = document.getElementById(elementid)
          document.execCommand('insertHTML', false, '<br>');               
          NEWeditorContent.appendChild(img);
          document.execCommand('insertHTML', false, '<br>');
          
        },
        false
      );

      if (file) {
        console.log("s");
        reader.readAsDataURL(file);
      }
    },
    

      addphone(){
         var url = prompt("Enter the Number internationalformat (e.g. +27123457890")
         document.execCommand("createLink", false, 'tel:'+url);
       },
       addemail(){
         var url = prompt("Enter the Number internationalformat (e.g. +27123457890")
         document.execCommand("createLink", false, 'mailto:'+url);
       },
       link() {
    var url = prompt("Enter the URL");
    document.execCommand("createLink", false, url);
    },
      
      LikePost(post){
        let UserhasLiked = post.Likes.find(obj => obj.Likedbyid === this.UserRecord.id)
        if(!UserhasLiked){
        let newlike = {
          Likedby: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},
          Likedbyid: this.UserRecord.id,
          createdon: new Date(),
            relatedtype: 'Social Post',
            relatedid: post.id,
            relatedowner: post.Creatorid
        }
        // post.Likes.push(newlike)
        db.collection('socialsitelikes').add(newlike).then(doc => {
          if(newlike.Likedbyid !== post.Creatorid){
          const NewNotification = {
                    postid: post.id,
                    Type: 'New Like',
                    Header: this.UserRecord.Full_Name+' likes your post',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: post.Creator.Full_Name,
                    Ownerid: post.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+post.id,
                    Message: 'Click to view Likes',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
        })
        }
        else{
          alert('you already liked this item')
        }
      },
      CommentReplyActivate(i,comment){
        // comment.Replying = true
        setTimeout(() => {
          let elmnt = document.getElementById(i+'commentreply')
        elmnt.style.display = 'block'
        console.log(comment)
        console.log(elmnt)
        }, 300);
        
      },
      
      ReplytoComment(comment,i){
          if(!comment.Replies){
            comment.Replies = []
          }
          let inputelmnt = document.getElementById(comment.id+'replyinputchip')
          let NewReply = 
          {
            content: inputelmnt.value,
            Likes: [],
            Shares: [],
            tags: [],
            Replies: [],
            Creator: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},          
            Creatorid: this.UserRecord.id,
            creatorname: this.UserRecord.Full_Name,
            createdon: new Date(),
            Comments: [],
            relatedtype: 'Social Comment',
            relatedid: comment.id,
            relatedowner: comment.Creatorid
            
          }
          
          if(this.UserRecord.Profile_Photo){
            NewReply.creatorimg = this.UserRecord.Profile_Photo
            }
           db.collection('socialsitereplies').add(NewReply).then(doc => {
          if(NewReply.Creatorid !== comment.Creatorid){
          const NewNotification = {
                    commentid: comment.id,
                    Type: 'New Like',
                    Header: this.UserRecord.Full_Name+' replied to your comment',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: comment.Creator.Full_Name,
                    Ownerid: comment.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+comment.id,
                    Message: 'Click to view Comments',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
        })
          comment.Replying = false
          this.NewReplyInput = ''
          inputelmnt.value = ''
        },

        CommenttoPost(post){
          if(!post.Comments){
            post.Comments = []
          }
          let inputelmnt = document.getElementById('commentinputchip')
          let expandelmnt = document.getElementById(post.id+'commentpanel')
          let NewComment = 
          {
            content: inputelmnt.value,
            Likes: [],
            Shares: [],
            tags: [],
            Creator: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},          
            Creatorid: this.UserRecord.id,
            creatorname: this.UserRecord.Full_Name,
            createdon: new Date(),
            Replies: [],
            relatedtype: 'Social Post',
            relatedid: post.id,
            relatedowner: post.Creatorid
            
          }
          post.Comments.push(NewComment)
          if(this.UserRecord.Profile_Photo){
          NewComment.creatorimg = this.UserRecord.Profile_Photo
        }
          db.collection('socialsitecomments').add(NewComment).then(doc => {
          if(NewComment.Creatorid !== post.Creatorid){
          const NewNotification = {
                    postid: post.id,
                    Type: 'New Comment',
                    Header: this.UserRecord.Full_Name+' commented on your post',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: post.Creator.Full_Name,
                    Ownerid: post.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+post.id,
                    Message: 'Click to view Post',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
        })
          post.NewCommentInput = ''
          inputelmnt.value = ''
          expandelmnt.click()
        },
      LikeReply(reply){
        let UserhasLiked = reply.Likes.find(obj => obj.Likedbyid === this.UserRecord.id)
        if(!UserhasLiked){
        let newlike = {
          Likedby: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},
          Likedbyid: this.UserRecord.id,
          createdon: new Date(),
          relatedtype: 'Social Reply',
            relatedid: reply.id,
            relatedowner: reply.Creatorid
        }
        // post.Likes.push(newlike)
        db.collection('socialsitelikes').add(newlike).then(doc => {
          if(newlike.Likedbyid !== reply.Creatorid){
          const NewNotification = {
                    replyid: reply.id,
                    Type: 'New Like',
                    Header: this.UserRecord.Full_Name+' likes your comment',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: reply.Creator.Full_Name,
                    Ownerid: reply.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+reply.id,
                    Message: 'Click to view Likes',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
                
        })
        }
        else{
          alert('you already liked this item')
        }
      },
      ReplytoReply(reply,comment){
        if(!reply.Replies){
            reply.Replies = []
          }
          console.log(reply)
          let inputelmnt = document.getElementById(reply.id+'replytoreplyinputchip')
          let NewReply = 
          {
            content: inputelmnt.value,
            Replies: [],
            Likes: [],
            Shares: [],
            tags: [],
            Creator: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},          
            Creatorid: this.UserRecord.id,
            creatorname: this.UserRecord.Full_Name,
            createdon: new Date(),
            Comments: [],
            relatedtype: 'Social Reply',
            relatedid: comment.id,
            relatedowner: reply.Creatorid
            
          }
          
          if(this.UserRecord.Profile_Photo){
            NewReply.creatorimg = this.UserRecord.Profile_Photo
            }
           db.collection('socialsitereplies').add(NewReply).then(doc => {
          if(NewReply.Creatorid !== reply.Creatorid){
          const NewNotification = {
                    replyid: reply.id,
                    Type: 'New Like',
                    Header: this.UserRecord.Full_Name+' replied to your comment',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: reply.Creator.Full_Name,
                    Ownerid: reply.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+reply.id,
                    Message: 'Click to view Comments',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
        })
          reply.Replying = false
          this.NewReplyInput = ''
          inputelmnt.value = ''
      },
      LikeComment(comment){
        let UserhasLiked = comment.Likes.find(obj => obj.Likedbyid === this.UserRecord.id)
        if(!UserhasLiked){
        let newlike = {
          Likedby: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},
          Likedbyid: this.UserRecord.id,
          createdon: new Date(),
          relatedtype: 'Social Comment',
            relatedid: comment.id,
            relatedowner: comment.Creatorid
        }
        // post.Likes.push(newlike)
        db.collection('socialsitelikes').add(newlike).then(doc => {
          if(newlike.Likedbyid !== comment.Creatorid){
          const NewNotification = {
                    commentid: comment.id,
                    Type: 'New Like',
                    Header: this.UserRecord.Full_Name+' likes your comment',
                    Content: 'Click to view Likes',
                    CreatorFullName: this.UserRecord.Full_Name,
                    CreatorID: this.UserRecord.id,
                    Owner: comment.Creator.Full_Name,
                    Ownerid: comment.Creatorid,
                    Read: false,
                    Path: '/SitePosts/'+comment.id,
                    Message: 'Click to view Likes',
                    Date: new Date()
                    }
                    db.collection('notifications').add(NewNotification).then(notedoc => {

                    })
          }
        })
        }
        else{
          alert('you already liked this item')
        }
      },
      CancelPost(){
        this.postelmnt.innerHTML = ''
        this.CancelPostActive()
      },
      CreatePost(){
        // let postelmnt = document.getElementById('postinput')
        let postinput = this.postelmnt.innerHTML
        let NewPost = {
          Likes: [],
          Shares: [],
          tags: [],
          Creator: {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id},          
          Creatorid: this.UserRecord.id,
          creatorname: this.UserRecord.Full_Name,
          post: postinput,
          createdon: new Date(),
          Comments: []
        }
        if(this.UserRecord.Profile_Photo){
          NewPost.creatorimg = this.UserRecord.Profile_Photo
        }
        db.collection('socialsiteposts').add(NewPost)
        console.log(NewPost.post)
        this.CancelPost()
      },
    },
}

</script>

<style>
.postinputbox{
  outline: rgb(111, 204, 247);
  outline-width: 1px;
  outline-style: solid;
  background-color: white;
  min-height: 80px;
}
.postoutline {
  outline: 1px solid #dedee9;
  background-color: grey;
}
.postoutline:focus {
  outline: 1px solid #dedee9;
  background-color: white;
}
.Chipinput{
  outline: rgb(111, 204, 247);
  display: inline-block;
  padding: 0 25px;
  height: 35px;
  width: 90%;
  font-size: 16px;
  line-height: 50px;
  border-radius: 25px;
  border-color: rgb(231, 231, 231);
  border-style: solid;
  background-color: #f0f2f5;
}
.commentblock {
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 25px;
  background-color: #f0f2f5
}
.commentpost{
  background-color: #87B6E6  
}
.greyBG{
  background-color: #f0f2f5;
}
</style>       
        